export const MAX_THUMBNAIL_SIZE = 3000000;